(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('CategoryController', CategoryController);

    CategoryController.$inject = ['$log', '$state', '$rootScope', '$translate', '$localStorage', 'CategoryService'];

    function CategoryController($log, $state, $rootScope, $translate, $localStorage, CategoryService) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();


        // FUNCITONS PUBLIC
        vm.pageLoaded = pageLoaded;
        vm.book = book;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        loadCategoryTiles();

        return vm;


        // FUNCTION DECLARATIONS
        function loadCategoryTiles() {
            CategoryService.loadCategories().then(successCategories, error);
        }


        function successCategories(response) {
            $log.debug('CategoryController | Fetching category tiles', response.data);
            vm.categories = response.data;
        }

        function error(response) {
            $log.debug('CategoryController | ERROR:',response.data);
        }

        function pageLoaded() {
            if (vm.categories) {
                return true;
            }
            return false;
        }

        function book(itemId) {
            $log.debug('CategoryController | opening category with id',itemId);
            $state.go('part', {'id':itemId});
        }

    }
})();
